import { useEffect } from 'react';

const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;

export function useClosingConfirmation(enabled: boolean = true) {
  useEffect(() => {
    if (!tg) return;

    if (enabled) {
      tg.enableClosingConfirmation();
    } else {
      tg.disableClosingConfirmation();
    }

    return () => {
      tg.disableClosingConfirmation();
    };
  }, [enabled]);
}
